import React from 'react';
import { useTranslation } from 'next-i18next';

const Testimonials = () => {
  const { t } = useTranslation('common');

  const testimonials = [
    {
      text: t('testimonial_1_text'),
      author: t('testimonial_1_author'),
      role: t('testimonial_1_role'),
      avatar: '🎬'
    },
    {
      text: t('testimonial_2_text'),
      author: t('testimonial_2_author'),
      role: t('testimonial_2_role'),
      avatar: '🛒'
    },
    {
      text: t('testimonial_3_text'),
      author: t('testimonial_3_author'),
      role: t('testimonial_3_role'),
      avatar: '📱'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            {t('testimonials_title')}
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 shadow-md">
              <div className="mb-4">
                <div className="flex text-yellow-400 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <span key={i}>⭐</span>
                  ))}
                </div>
                <p className="text-gray-700 italic leading-relaxed">
                  "{testimonial.text}"
                </p>
              </div>
              <div className="flex items-center">
                <div className="text-3xl mr-3">{testimonial.avatar}</div>
                <div>
                  <div className="font-semibold text-gray-800">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-gray-600">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;